import React, { useEffect, useMemo } from 'react';
import { Banner } from 'src/@vymo/ui/blocks';
import { getDetails } from 'src/models/details/selectors';
import {
  clearModuleButtons,
  setModuleButtons,
} from 'src/models/moduleButtons/slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// TODO: Move to modals
import { ANALYTICS_TYPE_REVYRE_DETAILS } from 'src/workspace/analytics/constants';
import { trackAnalyticsActions } from 'src/workspace/analytics/queries';
import { setAxiosErrorDescriptionHandler } from 'src/workspace/axios';
import { renderDialog } from 'src/workspace/slice';
// eslint-disable-next-line vymo-ui/restrict-import
import { REVYRE_FORM } from '../constants';
import { CASE } from './constant';
import DetailsBody from './detailsBody';
import ProfileCard from './profileCard';
import {
  getModuleButtons,
  getReferredModuleActions,
  updateBreadcrumbs,
} from './queries';
import { getNotification, getPhoneCallDetails } from './selector';
import { clearPhoneDetails, setError } from './slice';
import styles from './index.module.scss';

function Details360(props) {
  const { domainType, entityId, revyre, workflowType } = props;
  const details = useAppSelector((state) => getDetails(state, entityId));
  const dispatch = useAppDispatch();

  const referredActions = useMemo(
    () => getReferredModuleActions(details, props, dispatch),
    [details, dispatch, props],
  );

  const { activityId: callActivityId } = useAppSelector((state) =>
    getPhoneCallDetails(state),
  );

  const { message, messageId, variant } = useAppSelector(getNotification);

  useEffect(() => {
    if (!revyre) {
      return undefined;
    }

    trackAnalyticsActions({
      type: ANALYTICS_TYPE_REVYRE_DETAILS,
      isPageView: true,
      module: workflowType || domainType,
      payload: props,
    });

    return setAxiosErrorDescriptionHandler((errorDescription) => {
      dispatch(
        setError({
          message: errorDescription,
          messageId: String(Date.now()),
        }),
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, revyre]);

  useEffect(() => {
    const moduleButtons = getModuleButtons(referredActions);
    const isCaseWorkflow =
      revyre && domainType === 'workflow' && workflowType === CASE;
    const shouldSetModuleButtons = revyre
      ? moduleButtons.length &&
        (details?.allowedActions?.length > 0 || isCaseWorkflow)
      : moduleButtons.length;

    if (shouldSetModuleButtons) {
      dispatch(setModuleButtons(moduleButtons));
    }

    return () => {
      dispatch(clearModuleButtons());
    };
  }, [details, dispatch, domainType, referredActions, revyre, workflowType]);

  useEffect(() => {
    if (details?.inputsMap) {
      updateBreadcrumbs(dispatch, props, details?.inputsMap);
    }
  }, [details?.inputsMap, dispatch, props]);

  useEffect(() => {
    if (callActivityId && callActivityId === entityId) {
      dispatch(
        renderDialog({
          id: REVYRE_FORM,
          props: {
            domainType: 'activity',
            entityId: callActivityId,
            type: 'update',
            activityType: details?.inputsMap?.activityType,
            isPostCallForm: true,
          },
        }),
      );

      dispatch(clearPhoneDetails());
    }
  }, [callActivityId, dispatch, entityId, details?.inputsMap?.activityType]);

  return (
    <div className={styles.detailsWrapper}>
      {message && (
        <Banner
          key={messageId}
          message={message}
          variant={variant}
          position="topRight"
          duration={10000}
          closeable
        />
      )}
      <div className={styles.detailsWrapper__detailsGutter}>
        <ProfileCard {...props} />
        <DetailsBody {...props} />
      </div>
    </div>
  );
}

export default Details360;
